import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from 'shadcn/lib/utils';

function Progress({ className, value, ...props }) {
    return (
        <>
            <style>{`
                @keyframes progress-indeterminate {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(400%);
                    }
                }
            `}</style>
            <ProgressPrimitive.Root
                data-slot="progress"
                className={cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className)}
                {...props}
            >
                <ProgressPrimitive.Indicator
                    data-slot="progress-indicator"
                    className={cn(
                        'bg-primary h-full w-full flex-1 transition-all',
                        value === null || value === undefined
                            ? '[animation:progress-indeterminate_2s_linear_infinite]'
                            : '',
                    )}
                    style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
                />
            </ProgressPrimitive.Root>
        </>
    );
}

export { Progress };
